<template>
  <div class="modal-card">
    <div class="row-width-actions-bar">
      <div class="columns is-gapless is-vcentered is-border-bottom">
        <div class="column is-padding-left">
          <div class="has-text-dark is-size-6 is-uppercase">
            <span class="has-text-weight-medium">Modèle de contrat</span>
          </div>
        </div>
        <div class="column is-narrow is-border-left">
          <a
            class="page-header-btn is-small is-square"
            @click="close">
            <span class="icon is-size-4 has-text-dark"><i class="fal fa-times"></i></span>
          </a>
        </div>
      </div>
    </div>
    <div
      class="notification is-warning is-padding-small is-marginless is-flex is-vcentered is-minH50p">
      <div class="is-self-centered has-text-centered w100 is-uppercase is-size-7">
        <b class="has-text-weight-medium">
          Vos modèles de contrat sont disponibles dans l'onglet "Document personnalisé"
        </b>
      </div>
    </div>
    <section class="modal-card-body is-clipped">
      <div class="is-margin-right is-margin-left">
        <div class="column">
          <v-input
            id="contract_name"
            v-validate="'required|min:2'"
            :name="'contract_name'"
            :model="contract.name"
            :errors-bag="errors"
            data-vv-value-path="val"
            data-vv-as="Nom du modèle"
            @input="val => contract.name = val">
            <r-label
              slot="label"
              :is-required="false"
              :label="'Nom du modèle'"
              :value="contract.name" />
          </v-input>
          <div
            v-if="nameExist"
            class="subtitle is-6 has-text-danger is-padding-top-xsmall">
            Ce nom de contrat existe déjà
          </div>
        </div>
        <div class="columns is-gapless is-centered has-background-white is-padding-top-small is-padding-bottom-small">
          <button
            @click="submit()"
            type="button"
            :disabled="nameExist"
            class="button is-uppercase is-fullwidth is-success">
            <span>Enregister modèle</span>
          </button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ContractModal',
  props: {
    source: {
      type: Array,
      required: true
    },
    active: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      contract: null,
      contractsName: null,
      create: false,
      inputList: []
    }
  },
  computed: {
    nameExist () {
      if (this.contractsName) {
        if (this.create) {
          return this.contractsName.includes(this.contract.name)
        } else {
          let contractsWithoutCurrentName = this.contractsName
          return contractsWithoutCurrentName.includes(this.contract.name)
        }
      } else {
        return false
      }
    }
  },
  created () {
    this.contract = this.source[0]
    this.create = this.source[1]
    this.getContracts()
  },
  methods: {
    async getContracts (query) {
      let params = {
        sort: 'name:asc',
        searchable_name: query,
        per_page: 200
      }
      let { data } = await this.$api.axios.get('custom-contracts', params)
      let items = data.items.filter(item => item.contract_type === 'promotion')
      if (!this.create) {
        const index = items.findIndex(x => x.pk === this.contract.pk)
        if (index >= 0) {
          items.splice(index, 1)
        }
      }
      this.contractsName = items.map(x => x.name)
      this.getInput(this.contract)
    },
    getInput (contract) {
      this.inputList = [
        contract.appel_de_fond_section,
        contract.home_page_section,
        contract.reservataire_section,
        contract.special_condition_section,
        contract.withdrawal_form_section
      ]
    },
    close () {
      this.$emit('close')
    },
    deleteEmptyInput (objects) {
      objects.forEach(object => {
        let i = object.mentions.findIndex(x => !x.content)
        if (i >= 0) object.mentions.splice(i, 1)
      })
    },
    submit () {
      this.deleteEmptyInput(this.inputList)
      this.$emit('submit', [this.contract, this.create])
    }
  }
}
</script>
